import {Color} from '~/constants/style';

export const containerStyles = {
  backgroundColor: Color.SidebarMain,
  maxHeight: '100vh',
  width: '100%',
  overflow: 'auto',
  maxWidth: '100% !important',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: '16px 40px 36px',
  fontFamily: "'Inter Variable', sans-serif",
};

export const contentWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
};

export const backButtonStyles = {
  marginBottom: '12px',
  maxWidth: '80px',
  width: '100%',
  lineHeight: '22px',
  textTransform: 'none',
  fontSize: '16px',
  fontWeight: 400,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: Color.Purple600,
  '&:hover': {
    backgroundColor: Color.BackButtonBackground,
  },
};

export const headerTitleStyles = {
  color: Color.Purple600,
  fontWeight: 600,
  fontSize: '24px',
  padding: '16px 0',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const summaryContainerStyles = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '24px',
  padding: '16px 0 16px',
};

export const summaryBoxStyles = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  justifyContent: 'flex-start',
  minHeight: '80px',
  alignItems: 'flex-start',
  gap: '9px',
};

export const summaryLabelStyles = {
  color: Color.TextPrimary,
  fontSize: '14px',
  fontWeight: 400,
};

export const summaryValueStyles = {
  color: Color.Grey500,
  fontSize: '16px',
  fontWeight: 600,
  width: '100%',
};

export const verticalDividerStyles = {
  borderColor: Color.Grey300,
};

export const amountLabelStyles = {
  fontSize: '16px',
  color: Color.TextPrimary,
  fontWeight: 400,
};

export const amountValueStyles = {
  fontSize: '32px',
  fontWeight: 600,
  lineHeight: 1,
  color: Color.Black,
};

export const billingTitleStyles = {
  fontSize: '24px',
  fontWeight: 600,
  color: Color.Purple600,
  marginBottom: '16px',
};

export const statusDropdownContainerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const statusButtonStyles = (
  color: string,
  disabled: boolean,
  loading: boolean
) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  backgroundColor: color,
  color: Color.White,
  fontWeight: 400,
  fontSize: 14,
  borderRadius: 2,
  height: 32,
  px: 1.5,
  py: 0.5,
  cursor: disabled || loading ? 'not-allowed' : 'pointer',
  opacity: disabled ? 0.7 : 1,
  boxShadow: 1,
  justifyContent: 'center',
});

export const statusMenuPaperStyles = {
  p: 1,
  borderRadius: 2,
  width: 120,
  maxHeight: 150,
  '& .MuiMenu-list': {
    gap: '0 !important',
    padding: '0 !important',
  },
  '& .MuiMenuItem-root': {
    margin: '0 !important',
    padding: '3px 0!important',
    minHeight: 'auto !important',
    lineHeight: '1 !important',
  },
};

export const statusMenuItemStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 1,
  padding: '0 !important',
  margin: '0 !important',
};

export const statusChipStyles = {
  backgroundColor: 'inherit',
  color: Color.White,
  fontWeight: 400,
  fontSize: 12,
  borderRadius: 2,
  width: 100,
  height: 20,
  textTransform: 'capitalize',
  justifyContent: 'center',
};

export const statusLoadingSpinnerStyles = {
  ml: 1,
};

export const statusArrowIconStyles = {
  fontSize: 24,
  width: 24,
  height: 24,
};

export const editClaimDialogContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
};

export const editClaimFieldContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};

export const editClaimFieldLabelStyles = {
  fontWeight: 500,
  color: 'text.primary',
};

export const editClaimSelectInputStyles = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    backgroundColor: Color.White,
    transition: 'all 0.2s ease-in-out',
    '& .MuiSelect-select': {
      padding: '12px 16px',
      fontSize: '14px',
      fontWeight: 400,
      color: Color.TextPrimary,
      lineHeight: '20px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: Color.Grey300,
      borderWidth: '1px',
      transition: 'border-color 0.2s ease-in-out',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: Color.PrimaryMain,
      borderWidth: '1px',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: Color.PrimaryMain,
      borderWidth: '1px',
    },
    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: Color.ErrorMain,
      borderWidth: '1px',
    },
  },
  '& .MuiSelect-icon': {
    color: Color.Grey400,
    transition: 'color 0.2s ease-in-out',
  },
  '& .MuiSelect-icon.Mui-focused': {
    color: Color.PrimaryMain,
  },
  '&:hover .MuiSelect-icon': {
    color: Color.PrimaryMain,
  },
};

export const editClaimErrorTextStyles = {
  mt: 1,
  fontSize: '12px',
};

export const disabledButtonStyles = {
  color: `${Color.Grey400} `,
  border: `1px solid ${Color.Grey300}`,
  backgroundColor: `${Color.Grey50} `,
  cursor: 'not-allowed',
  '&:hover': {
    backgroundColor: `${Color.Grey50} `,
    border: `1px solid ${Color.Grey300}`,
  },
};
export const editIconContainerStyles = {
  ...summaryBoxStyles,
  marginLeft: '160px',
};

export const editIconStyles = {
  cursor: 'pointer',
  width: 40,
  height: 40,
};

export const outstandingBalanceTitleStyles = {
  color: Color.PrimaryMain,
  fontWeight: 700,
  fontSize: '24px',
  ml: 2,
};

export const outstandingAmountLabelStyles = {
  mb: 0.5,
};

export const outstandingAmountValueStyles = {
  color: Color.PrimaryMain,
  fontWeight: 700,
};

export const textFieldStyles = {
  background: Color.White,
  borderRadius: '8px',
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
  },
  mb: 2,
};

export const amountStatusContainerStyles = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  mt: 1,
};

export const amountStatusBoxStyles = {
  marginTop: 2,
  marginBottom: 2,
  marginRight: 4,
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
};

export const amountStatusBoxWithLeftMarginStyles = {
  margin: 2,
  marginLeft: 4,
  marginRight: 4,
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
};

export const dialogBodyStyles = {
  p: 3,
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};

export const dialogButtonContainerStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 2,
  mt: 2,
};

export const bottomButtonContainerStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '16px',
};

export const headerContainerStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const bottomActionsContainerStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '16px',
};

export const paidAmountInputStyles = {
  background: 'white',
  width: '70%',
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    height: '48px',
  },
  '& .MuiOutlinedInput-input': {
    padding: '12px 14px',
  },
};

export const notificationInputStyles = {
  background: Color.Grey50,
  borderRadius: '10px',
  ml: 1.5,
  width: '70%',
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    height: '48px',
    width: '320px',
    backgroundColor: Color.Grey50,
    cursor: 'not-allowed',
    '& fieldset': {
      borderColor: Color.Grey300,
    },
    '&:hover fieldset': {
      borderColor: Color.Grey300,
    },
    '&.Mui-focused fieldset': {
      borderColor: Color.Grey300,
    },
  },
  '& .MuiOutlinedInput-input': {
    padding: '8px 14px',
    color: Color.Grey400,
    cursor: 'not-allowed',
  },
};

export const notificationSectionStyles = {
  mt: 2,
};

export const emailNotificationContainerStyles = {
  mb: 3,
  display: 'flex',
  flexDirection: 'column',
};

export const smsNotificationContainerStyles = {
  mb: 2,
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};

export const emailCheckboxStyles = {
  mb: 1,
  borderColor: 'primary.main',
  '& .MuiFormControlLabel-label': {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '22px',
  },
};

export const smsCheckboxStyles = {
  '& .MuiFormControlLabel-label': {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '22px',
  },
};

export const paidAmountLabelStyles = {
  fontWeight: 600,
  mb: 2,
};

export const outstandingAmountContainerStyles = {
  mt: 2,
};

export const amountDisplayContainerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  mt: 1,
};

export const editIconContainerInlineStyles = {
  summaryBoxStyles,
  marginLeft: '160px',
};

export const outstandingContainer = {
  mt: 2,
  ml: 2,
};
export const paidAmountContainer = {
  ml: 2,
};

export const paymentLinkContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '16px',
};

export const paymentLinkLabelStyles = {
  fontSize: '14px',
  color: Color.TextPrimary,
  fontWeight: 400,
};

export const paymentLinkStyles = {
  fontSize: '16px',
  fontWeight: 600,
  color: Color.PrimaryMain,
  textDecoration: 'underline',
  cursor: 'pointer',
  '&:hover': {
    color: Color.PrimaryDark,
  },
};
